import { Typography } from '@mui/material'

const FormHeading = ({heading,isRequired}) => {
  return (
   <Typography sx={{fontSize:'14px',fontWeight:500,color:'#726C6C',marginBottom:'2px',textTransform:'capitalize',wordBreak:'break-all'}}>{heading} {isRequired&&<span className='error' style={{fontSize:'16px'}}>*</span>}</Typography>
  )
}

export default FormHeading